import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CrudService } from "../../../crud/crud.service";
import { ActivatedRoute, Params } from '@angular/router';
import * as moment from 'moment';
import { Mensaje } from "../../../mensaje";
import { NotificationsService } from 'angular2-notifications';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { error } from 'console';


@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit {
  //dato: FormGroup;
  dato = [];
  tieneid;
  periodo_escolar;
  cargando = false;
  borrarCargando = false;
  materias_anteriores = [];
  mensajeResponse: Mensaje = new Mensaje(true);

  tamano = document.body.clientHeight;
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  constructor(private crudService: CrudService, private notificacion: NotificationsService, private route: ActivatedRoute, private router: Router, private fb: FormBuilder,
    private http: HttpClient
  ) { }

  ngOnInit() {
    // this.dato = this.fb.group({
    //   id: [''],
    //   materias_id: ["", [Validators.required]],
    //   activo: ['0', [Validators.required]],
    //   costo: [0, [Validators.required]],
    // });

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  path = "https://cum.api.managerescolar.app/"
  verMaterias(id: any): Observable<any> {
    let url = `https://cum.api.managerescolar.app/get-carrera-plan-materia-costo/${id}`
    return this.http.get(url)
  }

  cargarDatos(id) {
   this.periodo_escolar = null;

    if (id != undefined) {
      this.verMaterias(id).subscribe((resultado) => {
        if (resultado.status == 200) {
          //console.log(resultado.data);
          this.periodo_escolar = resultado.data

        }
      }, error => {

      })
    }

    //this.cargando = true;
    // this.http.get("https://cum.api.managerescolar.app/get-carrera-plan-materia-costo/" + event).subscribe((resultado: any = []) => {

    //   console.log(resultado);

    //   if (resultado.status == 200 && resultado.data != undefined) {
    //     console.log(resultado.data);
    //     this.periodo_escolar = resultado.data
    //   }
    // })
    // let param = {
    //   periodo: periodo_escolar,
    //   profesor: profesor,
    //   grupo: grupo
    // };

    // this.crudService.ver(event, "get-carrera-plan-materia-costo").subscribe(
    //   resultado => {
    //     if (resultado.status == 200) {
    //       console.log(resultado);

    //       // this.dato = resultado.data;
    //       // this.ultima_actualizacion = resultado.ultima_actualizacion ? resultado.ultima_actualizacion.date ? resultado.ultima_actualizacion.date : '' : '';
    //       // this.ultima_actualizacion_fecha = this.ultima_actualizacion ? moment(this.ultima_actualizacion).format('LL') : '';
    //       // this.ultima_actualizacion_hora = this.ultima_actualizacion ? moment(this.ultima_actualizacion).format('LTS') : '';
    //       // this.grupo = resultado.grupo;
    //       // this.materias = resultado.materia;
    //       // this.profesor = resultado.profesor;
    //       // this.carrera_plan = resultado.carrera_plan;
    //       // document.getElementById("CaragarLogos").click();
    //     } else {
    //       // this.mensajeResponse.titulo = "No configurado";
    //       // this.mensajeResponse.texto = "No se encontro datos";
    //       // this.mensajeResponse.clase = "warning";
    //       // this.mensaje(3);
    //     }
    //     this.cargando = false;
    //   },
    //   error => {
    //     // this.cargando = false;
    //     // this.cargando = false;
    //     // this.mensajeResponse.titulo = "Error";
    //     // this.mensajeResponse.texto = "Algo salio mal";
    //     // this.mensajeResponse.clase = "danger";
    //     // this.mensaje(3);
    //   }
    // );
  }

  enviar() {
    this.cargando = true
    document
      .getElementById("confirmarCalificacion")
      .classList.remove("is-active");
    this.crudService.crear(this.periodo_escolar,"materia-costo").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 201) {
          this.mensajeResponse.titulo = "Guardado";
          this.mensajeResponse.texto = "Se ha guardado correctamente";
          this.mensajeResponse.clase = "success";
          this.mensaje(3);
        } else {
          this.mensajeResponse.titulo = "No guardado";
          this.mensajeResponse.texto = "NO se ha guardado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Ocurrio un error inesperado ";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      })
  }

  // reset_form() {
  //   try {
  //     this.dato.reset();
  //     for (let item in this.dato) {
  //       const ctrl = <FormArray>this.dato[item];
  //       if (ctrl.controls) {
  //         if (typeof ctrl.controls.length == "number") {
  //           while (ctrl.length) {
  //             ctrl.removeAt(ctrl.length - 1);
  //           }
  //           ctrl.reset();
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  //   return true;
  // }

  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }
  // filtrar(materias){
  //   this.materias_anteriores = [];
  //   let nivel = this.dato.controls.nivel.value;
  //   let my_id = this.dato.controls.id.value;
  //   let carrera_plan = this.dato.controls.carreras_planes_id.value;
  //   console.log(my_id,carrera_plan,nivel);
  //   materias.forEach(element => {
  //     if(carrera_plan==element.carreras_planes_id  && my_id!=element.id && element.nivel<nivel){
  //       this.materias_anteriores.push(element);
  //     }
  //   });

  //   console.log(this.dato.value);
  // }

}